import React from 'react'
import MainHeadToAppend from './MainHeadToAppend'

function Header() {
  return (
    <div className="MainTopButtonWrapper">
      <MainHeadToAppend/>
    </div>
  )
}

export default Header